module.exports = __webpack_public_path__ + "img/nature-8.5d5b5a4e.jpg";